/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Offset_SubtractInputs */

const en_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract`)
};

const fr_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustraire`)
};

const de_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrahieren`)
};

const it_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrarre`)
};

const ru_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычесть`)
};

const es_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sustraer`)
};

const zh_cn2_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减去`)
};

const ja_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減算`)
};

const hi_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटाना`)
};

const pt_pt2_dialogue_list_export_offset_subtract = /** @type {(inputs: Dialogue_List_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrair`)
};

/**
* | output |
* | --- |
* | "Subtract" |
*
* @param {Dialogue_List_Export_Offset_SubtractInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_offset_subtract = /** @type {((inputs?: Dialogue_List_Export_Offset_SubtractInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Offset_SubtractInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_offset_subtract(inputs)
	if (locale === "de") return de_dialogue_list_export_offset_subtract(inputs)
	if (locale === "it") return it_dialogue_list_export_offset_subtract(inputs)
	if (locale === "ru") return ru_dialogue_list_export_offset_subtract(inputs)
	if (locale === "es") return es_dialogue_list_export_offset_subtract(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_offset_subtract(inputs)
	if (locale === "ja") return ja_dialogue_list_export_offset_subtract(inputs)
	if (locale === "hi") return hi_dialogue_list_export_offset_subtract(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_offset_subtract(inputs)
	return en_dialogue_list_export_offset_subtract(inputs)
});